import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  EMPTY_CLIENT,
  normalizeClient,
  normalizeGstin,
  normalizePan,
} from "./clientValidation";

export function exportClientsToExcel(clients) {
  const rows = clients.map((client) => ({
    "Client ID": client.id || "",
    "Client Name": client.name || "",
    PAN: client.pan || "",
    GSTIN: client.gstin || "",
    "Contact Person": client.contactPerson || client.contact || "",
    Mobile: client.mobile || "",
    "Additional Contacts": (client.additionalContacts || []).map((x) => `${x.name || ""}:${x.mobile || ""}`).join(" | "),
    Email: client.email || "",
    "Address 1": client.address1 || "",
    "Address 2": client.address2 || "",
    City: client.city || "",
    State: client.state || "",
    PIN: client.pinCode || "",
    Remarks: client.remarks || client.notes || "",
    Status: client.status || "Active",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = [
    { wch: 24 }, { wch: 30 }, { wch: 14 }, { wch: 18 },
    { wch: 24 }, { wch: 16 }, { wch: 28 }, { wch: 28 },
    { wch: 28 }, { wch: 18 }, { wch: 18 }, { wch: 10 },
    { wch: 32 }, { wch: 12 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

  const instructions = [
    ["CLIENT IMPORT INSTRUCTIONS"],
    [""],
    ["1. Do not edit or delete the Client ID for existing clients."],
    ["2. Rows with a valid Client ID will update the matching existing client."],
    ["3. Leave Client ID blank only when adding a new client."],
    ["4. If a Client ID is present but does not exist, that row will be skipped."],
    ["5. Client Name and PAN are mandatory."],
    ["6. Duplicate PANs will be shown as warnings before import."],
    ["7. For existing Client IDs, blank Excel cells do NOT erase existing Client Master data."],
  ];

  const instructionSheet = XLSX.utils.aoa_to_sheet(instructions);
  instructionSheet["!cols"] = [{ wch: 95 }];
  XLSX.utils.book_append_sheet(workbook, instructionSheet, "Instructions");

  const output = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([output], { type: "application/octet-stream" }),
    `clients-${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}

export function exportClientImportErrors(invalidRows) {
  const rows = invalidRows.map((item) => ({
    "Excel Row": item.row,
    "Client Name": item.name || "",
    PAN: item.pan || "",
    GSTIN: item.gstin || "",
    "Validation Error": item.reason || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = [
    { wch: 12 },
    { wch: 32 },
    { wch: 16 },
    { wch: 20 },
    { wch: 55 },
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invalid Rows");

  const output = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(
    new Blob([output], { type: "application/octet-stream" }),
    `client-import-errors-${new Date().toISOString().slice(0, 10)}.xlsx`
  );
}

export async function readClientsFromExcel(file) {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data);
  const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: false });
  const aliases = {
    id:["Client ID","clientId","id"], name:["Client Name","Name","name"], pan:["PAN","pan"], gstin:["GSTIN","gstin"],
    contactPerson:["Contact Person","Contact","contactPerson","contact"], mobile:["Mobile","mobile"], email:["Email","email"],
    address1:["Address 1","address1"], address2:["Address 2","address2"], city:["City","city"], state:["State","state"],
    pinCode:["PIN","pinCode"], remarks:["Remarks","Notes","remarks","notes"], status:["Status","status"],
    latitude:["Latitude","latitude"], longitude:["Longitude","longitude"], geoRadiusMeters:["Geo Radius","Geo Radius Metres","Geo Radius Meters","geoRadiusMeters"]
  };
  const text=(v)=>v===null||v===undefined?"":String(v).trim();
  return rows.map((row,index)=>{
    const raw={...EMPTY_CLIENT}; const present=[];
    Object.entries(aliases).forEach(([field,names])=>{ let found=false,value=""; for(const name of names){ if(Object.prototype.hasOwnProperty.call(row,name)){found=true;value=row[name];break;} } if(!found)return; value=text(value); if(value==="")return; present.push(field); raw[field]=value; });
    raw.id=text(raw.id); raw.pan=normalizePan(raw.pan); raw.gstin=normalizeGstin(raw.gstin); raw.status=text(raw.status)||"Active";
    return {...normalizeClient(raw),importRowNumber:index+2,importPresentFields:present};
  });
}
